import React from 'react';

import { DataList, Link, Stack, Thumbnail } from '@tiendanube/components';

const { Row, Cell } = DataList;

function ProductRowSkeleton(): JSX.Element {
  return (
    <Row id="id">
      <Cell >
        <Stack justify="flex-start" align="center">
          <Stack.Item>
            <Thumbnail.Skeleton
              aspectRatio="1-1"
              width="48px"
            />
          </Stack.Item>
          <Stack.Item >
            <Link.Skeleton />
          </Stack.Item>
        </Stack>
      </Cell>
    </Row>
  );
}

export default ProductRowSkeleton;
